/* eslint-disable complexity */
/* eslint-disable react/prop-types */
/* eslint-disable no-console */
/* eslint-disable max-statements */
import {FormControl, InputLabel, Card, CardContent, Box, ToggleButtonGroup, ToggleButton, Link} from '@deere/fuel-react';
import {useDispatch, useSelector} from 'react-redux';
import '../../css/margin.style.css';
import {setIsPasswordIssue} from '../../redux/features/passwordIssue/passwordIssue.slice';
import {show} from '../../redux/features/modal/modal.slice';
import {ContactUsSelectField} from '../custom/ContactUsSelectField';
import {setSelectedValue} from '../../redux/features/select/select.slice';
import {useEffect, useState} from 'react';

export const FormPasswordIssue = ({
    register, errors, appId, setValue
}) => {
    const isPasswordIssue = useSelector((state) => state.passwordIssue.value);
    const selectedApp = useSelector((state) => state.select.selectedValue);
    const apps = useSelector((state) => state.app.apps);
    const [appUrl, setAppUrl] = useState('');
    const dispatch = useDispatch();

    const findAppUrlById = (paramAppId, dbApps) => {
        if (!Array.isArray(dbApps)) {
            return;
        }
        const appOption = dbApps.find((app) => app.appId.trim().toUpperCase() === paramAppId.trim().toUpperCase());

        if (appOption) {
            setAppUrl('description' in appOption && appOption.description ? appOption.description : '');
        }
    };

    const findAppUrlBySelection = (selection, dbApps) => {
        if (!Array.isArray(dbApps)) {
            return;
        }
        const appOption = dbApps.find((app) => app.appName.trim().toUpperCase() === selection.trim().toUpperCase());

        if (appOption) {
            setAppUrl('description' in appOption && appOption.description ? appOption.description : '');
        }
    };

    useEffect(() => {
        if (typeof appId === 'string' && appId.trim().length > 0) {
            findAppUrlById(appId, apps);
        } else if (typeof selectedApp === 'string' && selectedApp.trim().length > 0) {
            findAppUrlBySelection(selectedApp, apps);
        }
    });

    const handleClickOpenPass = () => {
        dispatch(show({
            name: 'passwordModal',
            display: true
        }));
    };

    const handleChange = (event) => {
        event.preventDefault();
        dispatch(setIsPasswordIssue());
        dispatch(setSelectedValue(''));
        setAppUrl('');
    };

    const children = [
        <ToggleButton
            aria-label='yes'
            key='1'
            text='Yes'
            value={true}
        />,
        <ToggleButton
            aria-label='no'
            key='2'
            text='No'
            value={false}
        />
    ];

    const linkOption = (<Link
        href='#'
        onClick={handleClickOpenPass}
    >{'Password Management FAQs'}</Link>);

    const selectField = (<ContactUsSelectField
        appId={appId}
        errors={errors}
        fullWidth={true}
        label={'Which JDSN tool or application is this issue about?'}
        register={register}
        setValue={setValue}
    />);

    const footer = appUrl && !isPasswordIssue ? (<InputLabel className='mt-2'>
        {'If your question is about the business process, or a request for enhancements, please '}
        <Link
            href={`${appUrl}`}
            target={'_blank'}
        >{'contact the appropiate Business Owner'}</Link>
    </InputLabel>) : null;

    const formSection = (<>
        <Box>
            <Card>
                <CardContent>
                    <div className='mb-2'>
                        <FormControl
                            fullWidth
                            required={true}
                        >
                            <InputLabel>
                                {'Is this a password issue?'}
                            </InputLabel>
                        </FormControl>
                        <ToggleButtonGroup
                            exclusive
                            onChange={handleChange}
                            value={isPasswordIssue}
                        >
                            {children}
                        </ToggleButtonGroup>
                    </div>
                    {isPasswordIssue ? linkOption : selectField}
                    {footer}
                </CardContent>
            </Card>
        </Box>
    </>);

    return formSection;
};
